import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_INFO_FEATURE_KEY, UserInfoState } from './user-info.reducer';

export const selectUserInfoState = createFeatureSelector<UserInfoState>(USER_INFO_FEATURE_KEY);

export const selectUserInfo = createSelector(selectUserInfoState, (state: UserInfoState) => state.userInfo);

export const selectUserInfoLoaded = createSelector(selectUserInfoState, (state: UserInfoState) => state.loaded);

export const selectIsSetUserInfo = createSelector(selectUserInfoState, (state: UserInfoState) => state.isSetUserInfo);
